<template>
  <v-footer class="pa-3">
    Front-end developed with VUE&nbsp
    <!-- <v-icon small color="red">fas fa-heart</v-icon>&nbspand&nbsp -->
    <v-icon small color="green">fab fa-vuejs</v-icon>
    <v-spacer></v-spacer>
    <div>&copy; {{ new Date().getFullYear() }}</div>
  </v-footer>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
</style>
